import { Route, RouteConfig } from 'vue-router'

export const Index: RouteConfig = {
  path: '/school-matches/:id',
  name: 'school_matches',
  component: () => import('../activity/school-matches/index.vue'),
  meta: {
    title: '校内赛',
  },
  props: true,
}

export const Data: RouteConfig = {
  path: '/school-matches/:id/data',
  name: 'school_matches_data',
  component: () => import('../activity/school-matches/Data.vue'),
  meta: { title: '校内赛' },
  props: true,
}

export const Intro: RouteConfig = {
  path: '/school-matches/:id/intro',
  name: 'school_matches_intro',
  component: () => import('../activity/school-matches/Intro.vue'),
  meta: {
    title: '校内赛',
  },
  props: true,
}

export const Rank: RouteConfig = {
  path: '/school-matches/:id/rank',
  name: 'school_matches_rank',
  component: () => import('../activity/school-matches/Rank.vue'),
  meta: {
    title: '校内赛排名',
  },
  props: (r: Route) => ({ activity: r.params.id, id: +r.query.type || 0 }),
}

const TXPRoutes = [
  {
    path: '/txp-matches/:id',
    name: 'txp_matches',
    component: () => import('../activity/school-matches/TIndex.vue'),
    meta: {
      title: '赛事主页',
    },
    props: true,
  },
  {
    path: '/txp-matches/:id/rank',
    name: 'txp_matches_rank',
    component: () => import('../activity/school-matches/TRank.vue'),
    meta: {
      title: '赛事排名',
    },
    props: true,
  },
  {
    path: '/txp-matches/:id/group/:gid',
    name: 'txp_matches_group',
    component: () => import('../activity/school-matches/TGroup.vue'),
    props: (route: Route) => ({ ...route.params, ...route.query }),
    meta: {
      title: '组内排名',
    },
  },
]

export default [Index, Intro, Rank, Data, ...TXPRoutes]
